import { CheckCircle, Loader2, Circle } from 'lucide-react';

export default function PipelineProgress({ steps, completedSteps }) {
  return (
    <section className="max-w-3xl mx-auto px-6 py-8" data-testid="pipeline-progress">
      <div className="intake-card p-6">
        <h3 className="font-semibold text-slate-900 mb-4 flex items-center gap-2">
          <Loader2 className="w-5 h-5 text-[#0369A1] animate-spin" />
          Agent Pipeline Processing
        </h3>
        <div className="space-y-3">
          {steps.map((step, i) => {
            const isComplete = completedSteps.includes(step.name);
            const isActive = !isComplete && completedSteps.length === i;
            return (
              <div
                key={step.step}
                className={`flex items-center gap-3 p-3 rounded-xl transition-all duration-300 ${isComplete ? 'bg-emerald-50 border border-emerald-200' : isActive ? 'bg-sky-50 border border-sky-200' : 'bg-slate-50 border border-slate-100'}`}
                data-testid={`pipeline-step-${step.step}`}
              >
                <div className="flex-shrink-0">
                  {isComplete ? (
                    <CheckCircle className="w-5 h-5 text-emerald-500" />
                  ) : isActive ? (
                    <Loader2 className="w-5 h-5 text-[#0369A1] animate-spin" />
                  ) : (
                    <Circle className="w-5 h-5 text-slate-300" />
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <div className={`text-sm font-medium ${isComplete ? 'text-emerald-800' : isActive ? 'text-[#0369A1]' : 'text-slate-400'}`}>
                    Step {step.step}: {step.name}
                  </div>
                  <div className={`text-xs ${isComplete ? 'text-emerald-600' : isActive ? 'text-sky-600' : 'text-slate-400'}`}>
                    {step.desc}
                  </div>
                </div>
                {isComplete && <span className="text-xs text-emerald-600 font-medium">Done</span>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
